import { toRem } from '@marriott/mi-ui-library';
//TODO: These styles need to be added to global styles.
export const color = {
  'dark-scrim-mobile':
    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 34.78%, rgba(0, 0, 0, 0.62) 100%)',
  'dark-scrim-tablet':
    'linear-gradient(270deg, rgba(0, 0, 0, 0) 26.95%, rgba(0, 0, 0, 0.54) 67.69%, rgba(0, 0, 0, 0.62) 100%)',
  'dark-scrim-desktop':
    'linear-gradient(270deg, rgba(0, 0, 0, 0) 37.22%, rgba(0, 0, 0, 0.54) 68.51%, rgba(0, 0, 0, 0.62) 100%)',
  'light-scrim-mobile':
    'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.46) 34.78%, rgba(255, 255, 255, 0.54) 100%)',
  'light-scrim-tablet':
    'linear-gradient(270deg, rgba(255, 255, 255, 0) 26.95%, rgba(255, 255, 255, 0.46) 66.99%, rgba(255, 255, 255, 0.54) 100%)',
  'light-scrim-desktop':
    'linear-gradient(270deg, rgba(255, 255, 255, 0) 37.22%, rgba(255, 255, 255, 0.46) 68.51%, rgba(255, 255, 255, 0.54) 100%)',
  'base-10': '#1c1c1c',
  'base-20': '#ffffff',
};

//Adding some styles here as they are removed from shared/mi-ui-library
//TODO: we can move these mediaqueries and fonts to common
export const mediaQuery = {
  deskop: `screen and (max-width: ${toRem(1920)})`,
  mobileOnly: ` screen and (max-width: ${toRem(767)})`,
  minDesktop: ` screen and (min-width: ${toRem(1200)})`,
  tabletOnly: ` (min-width:${toRem(768)}) and (max-width:${toRem(991)})`,
  smallMobileOnly: ` screen and (max-width: ${toRem(350)})`,
  tabletMax: ` screen and (max-width: ${toRem(1199)})`,
};

export const fonts = {
  fontWeightMedium: '700',
  fontWeightRegular: '500',
};
